import React from "react";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";

import GridItem from "components/Grid/GridItem.js";
// import Quote from "components/Typography/Quote.js";
// core components
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// import Muted from "components/Typography/Muted.js";
// import CardFooter from "components/Card/CardFooter.js";

//lazy loading
import Image from "next/image";

import styles from "./ServicesSections.module.scss";

export default function SectionText() {
  const classes = styles;
  return (
    <div className={classes.containerWide}>


      <GridContainer justifyContent="center">


        <GridItem xs={12} sm={12} md={12} >
          <GridContainer spacing={{md:3}} direction="row" justifyContent="center" >
          <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                 
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                  
                  className={classes.imgCardTop}
                  src="/img/services/images/ga4-implementation.jpg"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    From July 2023, Google has announced GA will be deprecated to be replaced by GA4. We are the analytics OGs - call today!
                  </p>
                  <br />
                  <a href="/services/ga4-implementation-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                   
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                  
                  className={classes.imgCardTop}
                  src="/img/services/images/analytics-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    We are australia's leading analytics agency. Data is at the core of everything we do. Find out how we can help your company's analytics
                    <br /><br /><br />
                  </p>
                  <br />
                  <a href="/services/analytics-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                   
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                  
                  className={classes.imgCardTop}
                  src="/img/services/images/google-tag-manager-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    Google Tag Manager is our favourite tool. It interfaces with all our other services. If you need help wit your tags, we're here to help
                  </p>
                  <br />
                  <a href="/services/google-tag-manager-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                   
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                  
                  className={classes.imgCardTop}
                  src="/img/services/images/training-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    We offer a full range of Training services: in-house or offsite. For more detail, particularly on our google stack training - click below
                  </p>
                  <br />
                  <a href="/services/training"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                   
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                  
                  className={classes.imgCardTop}
                  src="/img/services/images/data-studio-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    Google Data Studio is our preferred reporting tool. It acomplishes 90% of your dashboarding needs, is easliy customisable and it is free! 
                  </p>
                  <br />
                  <a href="/services/data-studio-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                   
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                  
                  className={classes.imgCardTop}
                  src="/img/services/images/dashboards-and-reporting-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    Data itself doesnt give you the answers. You need to explain yourelf and visualize things for stakeholders. Check out our approach.
                  </p>
                  <br />
                  <a href="/services/data-visualization-and-reporting-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
